// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"h2","cusMtdicon":"h2"};